#import "./RecordingBlobDetails.graphql"
query SentenceRecordingContents($id: ID!, $pitchShift: Float) {
  sentenceRecordingContents(id: $id, pitchShift: $pitchShift) {
    ...recordingBlobDetails
  }
}
